@if (show) {
  <div>
    <p-dialog
      header="Select HIPPS Code"
      [(visible)]="show"
      [modal]="true"
      appendTo="body"
      [closable]="false"
      [minY]="70"
      [style]="{'width': '450px', 'min-height': '60vh', 'box-shadow': 'none'}"
      [maximizable]="false"
      [contentStyle]="{'min-height': '25vh', 'max-height': '80vh', 'height': 'auto'}"
      data-test-id="hipps-dialog-header"
      >
      <form [formGroup]="hippsCodeForm">
        <div class="field">
          <label for="hippsSearchInput" data-test-id="hipps-dialog-label">Search HIPPS Code: </label>
          <p-input-group>
            <input type="text" id="hippsSearchInput" pInputText formControlName="searchText" data-test-id="hipps-dialog-search-value"/>
            <button
              pButton
              type="button"
              icon="pi pi-search"
              [disabled]="!searchText.valid"
              (click)="searchForHippsCodes()"
              data-test-id="hipps-dialog-search-button"
              >
            </button>
          </p-input-group>
        </div>
        @if (hippsNotFound) {
          <div>HIPPS Code Not Found</div>
        }
        @if (!hippsNotFound) {
          <div class="field">
            <label data-test-id="hipps-code-list-label">Select HIPPS Code:</label>
            <p-listbox
              formControlName="selectedHippsCode"
              [options]="availableHipps"
              [listStyle]="{'max-height':'22rem'}"
              [style]="{'height':'22rem'}"
              data-test-id="hipps-code-list-listbox"
              >
            </p-listbox>
          </div>
        }
        @if (isLoadingHipps) {
          <p-progressSpinner></p-progressSpinner>
        }
      </form>
      <ng-template #footer>
        <button
          pButton
          severity="info"
          type="button"
          [icon]="cancelBtn.icon"
          [label]="cancelBtn.text"
          class="p-button-action"
          (click)="this.handleDialog(null)"
          data-test-id="hipps-dialog-cancel-button"
          >
        </button>
        <button
          pButton
          type="button"
          [icon]="submitBtn.icon"
          [label]="submitBtn.text"
          class="p-button-action"
          [disabled]="!selectedHippsCode.valid"
          (click)="this.handleDialog(selectedHippsCode.value)"
          data-test-id="hipps-dialog-select-button"
          >
        </button>
      </ng-template>
    </p-dialog>
  </div>
}
